import { useState } from 'react'
import { useLang } from '../../i18n/LanguageContext'

export default function Step3Contact({ data, onChange, onNext, onBack }) {
  const [errors, setErrors] = useState({})
  const { t } = useLang()

  const validate = () => {
    const e = {}
    if (!data.contactName?.trim()) e.contactName = t('onboarding.contactPersonRequired')
    if (!data.contactEmail?.trim()) e.contactEmail = t('onboarding.emailRequired')
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.contactEmail.trim()))
      e.contactEmail = t('onboarding.emailInvalid')
    setErrors(e)
    return Object.keys(e).length === 0
  }

  const handleNext = () => {
    if (validate()) onNext()
  }

  const sameAsPostal = data.sameAsPostalAddress !== false

  return (
    <div className="wizard__body">
      <h1 className="wizard__title">{t('onboarding.step3Title')}</h1>
      <p className="wizard__subtitle">
        {t('onboarding.step3Subtitle')}
      </p>

      <div className="form-row form-row--2">
        <div className="form-group">
          <label className="form-label form-label--required">{t('onboarding.contactPerson')}</label>
          <input
            className={`form-input ${errors.contactName ? 'form-input--error' : ''}`}
            type="text"
            placeholder="Ola Nordmann"
            value={data.contactName || ''}
            onChange={(e) => onChange({ contactName: e.target.value })}
            autoFocus
          />
          {errors.contactName && <div className="form-error">{errors.contactName}</div>}
        </div>

        <div className="form-group">
          <label className="form-label form-label--required">{t('onboarding.email')}</label>
          <input
            className={`form-input ${errors.contactEmail ? 'form-input--error' : ''}`}
            type="email"
            placeholder="ola@organisasjon.no"
            value={data.contactEmail || ''}
            onChange={(e) => onChange({ contactEmail: e.target.value })}
          />
          {errors.contactEmail && <div className="form-error">{errors.contactEmail}</div>}
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">{t('onboarding.phone')}</label>
        <input
          className="form-input"
          type="tel"
          placeholder="+47 999 99 999"
          value={data.contactPhone || ''}
          onChange={(e) => onChange({ contactPhone: e.target.value })}
        />
      </div>

      <hr style={{ border: 'none', borderTop: '1px solid var(--color-gray-200)', margin: '1.5rem 0' }} />

      <h3 style={{ fontSize: 'var(--font-size-base)', fontWeight: 600, marginBottom: '1rem', color: 'var(--color-gray-700)' }}>
        {t('onboarding.postalAddress')} <span style={{ fontWeight: 400, color: 'var(--color-gray-400)', fontSize: 'var(--font-size-sm)' }}>{t('onboarding.optional')}</span>
      </h3>

      <div className="form-group">
        <label className="form-label">{t('onboarding.streetAddress')}</label>
        <input
          className="form-input"
          type="text"
          placeholder="Storgata 1"
          value={data.postalAddress || ''}
          onChange={(e) => onChange({ postalAddress: e.target.value })}
        />
      </div>

      <div className="form-row form-row--3-1">
        <div className="form-group">
          <label className="form-label">{t('onboarding.city')}</label>
          <input
            className="form-input"
            type="text"
            placeholder="Oslo"
            value={data.postalCity || ''}
            onChange={(e) => onChange({ postalCity: e.target.value })}
          />
        </div>
        <div className="form-group">
          <label className="form-label">{t('onboarding.postalCode')}</label>
          <input
            className="form-input"
            type="text"
            placeholder="0001"
            maxLength={4}
            value={data.postalCode || ''}
            onChange={(e) => onChange({ postalCode: e.target.value })}
          />
        </div>
      </div>

      <hr style={{ border: 'none', borderTop: '1px solid var(--color-gray-200)', margin: '1.5rem 0' }} />

      <div className="form-group" style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={sameAsPostal}
            onChange={(e) => onChange({ sameAsPostalAddress: e.target.checked })}
            style={{ width: '1rem', height: '1rem' }}
          />
          <span style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-gray-700)' }}>
            {t('onboarding.sameAsPostal')}
          </span>
        </label>
      </div>

      {!sameAsPostal && (
        <>
          <h3 style={{ fontSize: 'var(--font-size-base)', fontWeight: 600, marginBottom: '1rem', color: 'var(--color-gray-700)' }}>
            {t('onboarding.visitingAddress')} <span style={{ fontWeight: 400, color: 'var(--color-gray-400)', fontSize: 'var(--font-size-sm)' }}>{t('onboarding.optional')}</span>
          </h3>

          <div className="form-group">
            <label className="form-label">{t('onboarding.streetAddress')}</label>
            <input
              className="form-input"
              type="text"
              placeholder="Storgata 1"
              value={data.visitingAddress || ''}
              onChange={(e) => onChange({ visitingAddress: e.target.value })}
            />
          </div>

          <div className="form-row form-row--3-1">
            <div className="form-group">
              <label className="form-label">{t('onboarding.city')}</label>
              <input
                className="form-input"
                type="text"
                placeholder="Oslo"
                value={data.visitingCity || ''}
                onChange={(e) => onChange({ visitingCity: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="form-label">{t('onboarding.postalCode')}</label>
              <input
                className="form-input"
                type="text"
                placeholder="0001"
                maxLength={4}
                value={data.visitingPostalCode || ''}
                onChange={(e) => onChange({ visitingPostalCode: e.target.value })}
              />
            </div>
          </div>
        </>
      )}

      <div className="wizard__actions">
        <button className="btn btn--secondary" onClick={onBack}>
          {t('onboarding.back')}
        </button>
        <button className="btn btn--primary" onClick={handleNext}>
          {t('onboarding.next')}
        </button>
      </div>
    </div>
  )
}
